import { render, staticRenderFns } from "./TwNewMail.vue?vue&type=template&id=5471e0bc&scoped=true&"
import script from "./TwNewMail.vue?vue&type=script&lang=js&"
export * from "./TwNewMail.vue?vue&type=script&lang=js&"
import style0 from "./TwNewMail.vue?vue&type=style&index=0&id=5471e0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471e0bc",
  null
  
)

export default component.exports